import { Grid, Paper, Typography } from '@mui/material';
import { type Theme, useTheme } from '@mui/material/styles';
import type { FormEventHandler, ReactNode } from 'react';

const getStyles = (theme: Theme) => ({
  appForm: {
    padding: theme.spacing(2)
  }
});

interface AppFormProps {
  onSubmit?: FormEventHandler<any>;
  title?: string;
  lineSpacing?: number;
  children?: ReactNode;
}

const AppForm = (props?: Partial<AppFormProps>) => {
  const theme = useTheme();
  const classes = getStyles(theme);
  return (
    <Paper variant="outlined" sx={classes.appForm}>
      <form noValidate autoComplete="off" onSubmit={props?.onSubmit}>
        <Grid container direction="column" spacing={props?.lineSpacing || 2}>
          <Grid size={12}>
            <Typography variant="h6">{props?.title}</Typography>
          </Grid>
          {props?.children}
        </Grid>
      </form>
    </Paper>
  );
};

export default AppForm;
